import { HttpLink } from '@apollo/client';
import { createApolloLinkMixin } from '../../lib/create-apollo-link-mixin';

const HopsXingOneApolloLinkThreeRuntimeMixin = createApolloLinkMixin(HttpLink);

export default HopsXingOneApolloLinkThreeRuntimeMixin;
